import React from 'react';

const ProjectsGridSkeleton = ({ count = 8 }) => (
  <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
    {Array.from({ length: count }, (_, index) => (
      <div
        key={`project-skeleton-${index + 1}`}
        className="flex min-h-[296px] flex-col rounded-xl border border-border/40 bg-card/20 p-5"
      >
        <div className="flex animate-pulse items-start gap-3">
          <div className="h-9 w-9 rounded-xl bg-muted/60" />

          <div className="min-w-0 flex-1 space-y-2">
            <div className="h-4 w-3/4 rounded-full bg-muted/60" />
            <div className="h-4 w-1/3 rounded-full bg-muted/50" />
            <div className="space-y-2 pt-1">
              <div className="h-3 w-full rounded-full bg-muted/45" />
              <div className="h-3 w-5/6 rounded-full bg-muted/40" />
            </div>
          </div>
        </div>

        <div className="my-6 flex flex-1 animate-pulse flex-col items-center justify-center">
          <div className="h-10 w-16 rounded-full bg-muted/55" />
          <div className="mt-3 h-3 w-24 rounded-full bg-muted/40" />
        </div>

        <div className="space-y-2 border-t border-border/35 pt-4">
          <div className="h-9 w-full animate-pulse rounded-xl bg-muted/55" />
          <div className="h-8 w-full animate-pulse rounded-xl bg-muted/40" />
        </div>
      </div>
    ))}
  </div>
);

export default ProjectsGridSkeleton;
